import { NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { TinyColor } from '@ctrl/tinycolor';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import type { DataFormModel } from '@shared/components/data-form/data-form.model';

@Component({
    selector: 'formly-color-picker',
    template: `
        <div class="bg-card p-5 mb-5 rounded-lg shadow space-y-2">
          <mat-label>{{props.label}} @if (this.field?.props?.required) {
            <span class="mat-mdc-form-field-required-marker mdc-floating-label--required font-normal"></span>
          }</mat-label>
          <div class="grid gap-2 grid-cols-6 sm:grid-cols-11 md:grid-cols-6 lg:grid-cols-10">
            @for (color of colors; track color) {
              <div class="w-7 h-7 rounded-full cursor-pointer hover:scale-125 transition-all" (click)="setColor(color)"
                        [ngStyle]="{'background-color': formControl?.value?.toLowerCase() === color ? 'transparent' : color, 
                            'box-shadow': formControl?.value?.toLowerCase() === color ? '0 0 0 3px inset ' + color + ', 0 0 5px ' + color : 'none' }">
              </div>
            }
          </div>
          <div>
            <mat-label class="block text-sm text-secondary">Hex</mat-label>
            <input class="border-b-2" [style.border-color]="formControl?.value" type="text" [formControl]="formControl" (change)="colorSelection()" />
          </div>
        </div>
        `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatLabel, NgStyle, FormsModule, ReactiveFormsModule]
})
export class ColorPickerCustomComponent extends FieldType<FieldTypeConfig> {
    colors: string[] = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"];
    
    /**
     * This function is use for set color
     * @param color 
     */
    setColor(color: string): void {
        this.formControl.setValue(color?.toUpperCase());
    }

    /**
     * This function is use for color change
     */
    colorSelection(): void {
        if (!this.formControl?.value) {
            this.field.formControl.setValue(null);
            return;
        }
        const color = new TinyColor(this.formControl.value as string)?.toHexString()?.toUpperCase();
        (this.field.model as DataFormModel)[this.field.key.toString()] = color;
        this.field.formControl.setValue(color);
    }
};
